export const enUS_title = {
  'title.default': 'Nordatec Smart Energy',
  'title.login': 'Login',
  'title.dashboard': 'APM - 3200 Asset and Performance Manager',
  'title.report': 'Report - BMS - 3000 Building Management System',
  'title.analyze': 'Analyze - BMS - 3000 Building Management System',
  'title.rooms': 'Rooms Control - BMS - 3000 Building Management System',
  'title.profiles': 'Energy Profiles - BMS - 3000 Building Management System',
  'title.tenants': 'Tenant Control - BMS - 3000 Building Management System',
  'title.notFount': '404'
};
